export default __webpack_public_path__ + "static/media/fermar-gray.87762034.webp";